import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';

export const fetchLoveRequests = createAsyncThunk(
  'loveRequests/fetchLoveRequests',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/love-requests');
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const sendLoveRequest = createAsyncThunk(
  'loveRequests/sendLoveRequest',
  async ({ receiverId, message, isSuperLike }, { rejectWithValue }) => {
    try {
      const response = await api.post('/love-requests', {
        receiver_id: receiverId,
        message,
        is_super_like: isSuperLike
      });
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const acceptLoveRequest = createAsyncThunk(
  'loveRequests/acceptLoveRequest',
  async (requestId, { rejectWithValue }) => {
    try {
      const response = await api.patch(`/love-requests/${requestId}/accept`);
      return { requestId, data: response.data };
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const declineLoveRequest = createAsyncThunk(
  'loveRequests/declineLoveRequest',
  async (requestId, { rejectWithValue }) => {
    try {
      const response = await api.patch(`/love-requests/${requestId}/decline`);
      return { requestId, data: response.data };
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

const initialState = {
  sent: [],
  received: [],
  loading: false,
  error: null,
};

const loveRequestsSlice = createSlice({
  name: 'loveRequests',
  initialState,
  reducers: {
    clearLoveRequestsError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLoveRequests.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchLoveRequests.fulfilled, (state, action) => {
        state.loading = false;
        state.sent = action.payload.sent || [];
        state.received = action.payload.received?.data || [];
      })
      .addCase(fetchLoveRequests.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(sendLoveRequest.fulfilled, (state, action) => {
        state.sent.push(action.payload);
      })
      .addCase(sendLoveRequest.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(acceptLoveRequest.fulfilled, (state, action) => {
        // Update received requests (when current user accepts a request)
        const receivedIndex = state.received.findIndex(req => req.id === action.payload.requestId);
        if (receivedIndex !== -1) {
          state.received[receivedIndex].status = 'accepted';
        }
        // Update sent requests (when someone else accepts current user's request)
        const sentIndex = state.sent.findIndex(req => req.id === action.payload.requestId);
        if (sentIndex !== -1) {
          state.sent[sentIndex].status = 'accepted';
        }
      })

      .addCase(declineLoveRequest.fulfilled, (state, action) => {
        const index = state.received.findIndex(req => req.id === action.payload.requestId);
        if (index !== -1) {
          state.received[index].status = 'declined';
        }
      });
  },
});

export const { clearLoveRequestsError } = loveRequestsSlice.actions;
export default loveRequestsSlice.reducer;
